import {
  always, applySpec, ifElse, isEmpty, join, map,
  path, pipe, prop, propEq, range,
} from 'rambda'

const skip = always('')

const spec = [
  prop('category'), // A
  prop('topic'), // B
  prop('siteId'), // C
  skip, // D
  skip, // E
  skip, // F
  skip, // G - requirements
  ...range(0, 6 * 3).fill(skip), // components
  skip, // Z - FAQ
  ...[
    'battery',
    'bonus',
    'cpu',
    'graphics',
    'memory',
    'ports',
    'resolution',
    'screen',
    'storageNvme',
    'storageSpace',
    'storageSsd',
    'weight',
  ].map(weight => path(['criteria', 'weights', weight])),
  skip, // AM - platform
  pipe(
    path(['criteria', 'minimalScores']),
    ifElse(isEmpty, always(''), JSON.stringify),
  ),
  ifElse(
    propEq('doCreateChildren', true),
    always('TRUE'),
    always('FALSE'),
  ),
  pipe(
    path(['criteria', 'filtersLaptop']),
    ifElse(isEmpty, always(''), JSON.stringify),
  ),
]

export default pipe(
  map(pipe(
    applySpec(spec),
    join('\t'),
  )),
  join('\n'),
)
